"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DropdownControl_1 = tslib_1.__importDefault(require("../DropdownControl"));
var translations_1 = require("../../../utils/translations");
var dropdowns_1 = require("../../../constants/dropdowns");
var LabelRotationControl = /** @class */ (function (_super) {
    tslib_1.__extends(LabelRotationControl, _super);
    function LabelRotationControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelRotationControl.prototype.render = function () {
        var _a = this.getControlProperties(), axisVisible = _a.axisVisible, axisLabelsEnabled = _a.axisLabelsEnabled, axisRotation = _a.axisRotation;
        var isDisabled = this.props.disabled || !axisVisible || !axisLabelsEnabled;
        return (react_1.default.createElement(DropdownControl_1.default, { value: axisRotation, valuePath: this.props.axis + ".rotation", labelText: "properties.axis.rotation", disabled: isDisabled, showDisabledMessage: !this.props.configPanelDisabled && isDisabled, properties: this.props.properties, pushData: this.props.pushData, items: translations_1.getTranslatedDropdownItems(dropdowns_1.rotationDropdownItems, this.props.intl) }));
    };
    LabelRotationControl.prototype.getControlProperties = function () {
        var _a, _b, _c, _d, _e;
        var axisProperties = (_b = (_a = this.props.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b[this.props.axis];
        var axisVisible = (_c = axisProperties === null || axisProperties === void 0 ? void 0 : axisProperties.visible) !== null && _c !== void 0 ? _c : true;
        var axisLabelsEnabled = (_d = axisProperties === null || axisProperties === void 0 ? void 0 : axisProperties.labelsEnabled) !== null && _d !== void 0 ? _d : true;
        var axisRotation = (_e = axisProperties === null || axisProperties === void 0 ? void 0 : axisProperties.rotation) !== null && _e !== void 0 ? _e : "auto";
        return {
            axisVisible: axisVisible,
            axisLabelsEnabled: axisLabelsEnabled,
            axisRotation: axisRotation,
        };
    };
    return LabelRotationControl;
}(react_1.default.PureComponent));
exports.default = react_intl_1.injectIntl(LabelRotationControl);
//# sourceMappingURL=LabelRotationControl.js.map